import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalTitle: {
    id: 'studio.UKaRLd',
    defaultMessage: 'Webhook secret',
  },
  docs: {
    id: 'studio.9PjpLU',
    defaultMessage: 'Learn more in the <link>documentation</link>',
  },
  webhookNameLabel: {
    id: 'studio.DTcSV4',
    defaultMessage: 'Webhook name',
  },
  webhookNameHelp: {
    id: 'studio.j8zOYp',
    defaultMessage: 'The name of the webhook this secret is tied to',
  },
  nameLabel: {
    id: 'studio.HAlOn1',
    defaultMessage: 'Name',
  },
  nameHelp: {
    id: 'studio.uwcEjh',
    defaultMessage: 'An optional name to give extra clarity what the secret is used for.',
  },
  badWebhookSecret: {
    id: 'studio.etX98x',
    defaultMessage: 'This must be a valid webhook secret',
  },
  close: {
    id: 'studio.rbrahO',
    defaultMessage: 'Close',
  },
  save: {
    id: 'studio.sFz8cs',
    defaultMessage: 'Save webhook secret',
  },
  deleteWarningTitle: {
    id: 'studio.SWlYDh',
    defaultMessage: 'Deleting webhook secret',
  },
  deleteWarning: {
    id: 'studio.h//KGh',
    defaultMessage:
      'Are you sure you want to delete this webhook secret? This action cannot be reverted.',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  delete: {
    id: 'studio.zHmd77',
    defaultMessage: 'Delete webhook secret',
  },
  deleteSuccess: {
    id: 'studio./JVlMb',
    defaultMessage: 'Successfully deleted webhook secret {name}',
  },
  deleteButton: {
    id: 'studio.zHmd77',
    defaultMessage: 'Delete webhook secret',
  },
  showSecret: {
    id: 'studio.wUlCgz',
    defaultMessage: 'Show secret',
  },
  hideSecret: {
    id: 'studio.brfiKZ',
    defaultMessage: 'Hide secret',
  },
});
